<template>
	<multiselect
		:class="{ 'active-filter': value && value.length > 0 }"
		v-model="internalValue"
		:options="groupedSalesChannelsOpts"
		group-label="group"
		group-values="options"
		group-select
		:multiple="multiple"
		label="text"
		track-by="value"
		:placeholder="placeholder"
		:taggable="taggable"
		v-bind="$attrs"
		@input="onInput"
	>
		<template v-slot:clear>
			<div class="multiselect__clear" @click="clearSelection"></div>
		</template>
		
		<template slot="option" slot-scope="props">
			<div v-if="props.option.$groupLabel" class="option__desc">
				<md-icon icon="folder" /> <strong>{{ props.option.$groupLabel }}</strong>
			</div>
			<div v-else class="option__desc">
				<span class="option__title">{{ props.option.text }}</span>
			</div>
		</template>
		
		<slot></slot>
	</multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
	name: "GroupedSalesChannelsSelect",
	components: {
		Multiselect
	},
	props: {
		value: {
			type: [Array, Object],
			default: () => []
		},
		multiple: {
			type: Boolean,
			default: true
		},
		placeholder: {
			type: String,
			default: "Seleccionar canales de venta"
		},
		taggable: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			internalValue: this.value
		};
	},
	computed: {
		groupedSalesChannelsOpts() {
			if (!this.$root.auxVars.salesChannelsOpts) {
				return [];
			}

			// Group sales channels by their salesChannelGroup
			const grouped = {};
			
			this.$root.auxVars.salesChannelsOpts.forEach(channel => {
				const groupName = channel.salesChannelGroup || 'Sin Grupo';
				
				if (!grouped[groupName]) {
					grouped[groupName] = [];
				}
				
				grouped[groupName].push(channel);
			});

			// Sort group names to ensure consistent order
			const sortedGroupNames = Object.keys(grouped).sort();

			// Convert to the format expected by vue-multiselect
			return sortedGroupNames.map(groupName => ({
				group: groupName,
				options: grouped[groupName].sort((a, b) => a.text.localeCompare(b.text))
			}));
		}
	},
	methods: {
		onInput(newValue) {
			this.internalValue = newValue;
			this.$emit('input', newValue);
		},
		clearSelection() {
			this.internalValue = this.multiple ? [] : null;
			this.$emit('input', this.internalValue);
		}
	},
	watch: {
		value(newValue) {
			this.internalValue = newValue;
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["salesChannelsOpts"]
		});
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>